import React, { useState, useEffect } from 'react';
import { Modal, message, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { templateService } from '../../utils/api';
import './TemplateActiveToggle.css';

const TemplateActiveToggle = () => {
    const { templateData, setTemplateData, docID, savingData, setSavingData } = useDocument();
    const [isActive, setIsActive] = useState(templateData?.isActive);

    useEffect(() => {
        setIsActive(templateData?.isActive);
    }, [templateData?.isActive]);

    const handleToggle = async (newActiveStatus) => {
        const statusText = newActiveStatus ? 'activate' : 'deactivate';
        Modal.confirm({
            title: `${statusText.charAt(0).toUpperCase() + statusText.slice(1)} Template`,
            content: `Are you sure you want to ${statusText} this template?`,
            okText: statusText.charAt(0).toUpperCase() + statusText.slice(1),
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    if (docID) {
                        const res = await templateService.updateTemplate({ templateId: docID, data: { isActive: newActiveStatus?.toString(), docType: 'milegrid' }, dispatch: setSavingData });
                        setTemplateData(res.data.data);
                        setIsActive(res?.data?.data?.isActive ?? newActiveStatus);
                        message.success(`Template ${statusText}d successfully.`);
                    }
                } catch (e) {
                    console.error('Error in onOk:', e);
                    message.error(`Failed to ${statusText} the template. Please try again.`);
                }
            },
        });
    };

    return (
        <div className='customSwitch'>
            <Switch
                className="template-switch"
                checked={isActive}
                onChange={handleToggle}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                title={templateData?.isActive ? 'Deactivate Template' : 'Activate Template'}
            />
        </div>
    );
};

export default TemplateActiveToggle;